<template>
	<div class="message-list--item-appointment-info-confirmed">
		<div class="message-list--item-appointment-info-confirmed-type">{{ data.type }}</div>
		<div class="message-list--item-appointment-info-confirmed-date">{{ date }} Uhr</div>
		<div v-if="customer" class="message-list--item-appointment-info-confirmed-extra">
			<div>Du findest den Termin ab sofort in deinem Kalender und kannst ihn dort auch bearbeiten.</div>
			<template v-if="data.linkEligible && hasLink">
				<div class="mt-2">
					<Button
						text="Zugangsdaten bearbeiten"
						icon="edit"
						@click="$emit('editAccessLink')"
					/>
				</div>
			</template>
			<div v-if="phoneNumber" class="mt-2">
				Telefonnummer: <a :href="'tel:' + phoneNumber">{{ phoneNumberFormatted }}</a>
			</div>
		</div>
		<div v-if="applicant" class="message-list--item-appointment-info-confirmed-extra">
			<div>Du findest den Termin ab sofort in deinem Kalender und kannst dort die Details einsehen.</div>
			<template v-if="data.linkEligible">
				<div v-if="hasLink" class="mt-2">
					<div>
						<a :href="message.appointment.accessLink" target="_blank">
							Klicke hier um den Link der Firma zu öffnen
						</a>
					</div>
					<div v-if="message.appointment.accessLinkUsername">
						Benutzername: {{ message.appointment.accessLinkUsername }}
					</div>
					<div v-if="message.appointment.accessLinkPassword">
						Passwort: {{ message.appointment.accessLinkPassword }}
					</div>
				</div>
				<template v-else>
					Die Zugangsdaten erhältst du rechtzeitig von der Firma.
				</template>
			</template>
			<div v-if="message.appointment && message.appointment.phone" class="mt-2">
				Du wirst angerufen unter der von dir hinterlegten Nummer {{ message.appointment.phone.formatted}},
				die wir deinem Gesprächspartner kurz vor dem Termin mitteilen.
			</div>
		</div>
	</div>
</template>

<script>
import {DateTime} from "luxon";
import {isEmptyOrNull} from "@/helper/String";
import Icon from "@/vue/icon/Icon.vue";
import Button from "@/vue/common/Button.vue";

export default {
	components: {Button, Icon},

	props: {
		message: {
			type: Object,
			required: true
		}
	},

	computed: {
		data ()
		{
			return JSON.parse(this.message.extraData);
		},
		customer ()
		{
			return this.message.recipientType.customer;
		},
		applicant ()
		{
			return this.message.recipientType.applicant;
		},
		date ()
		{
			return DateTime.fromFormat(this.data.date, 'y-LL-dd HH:mm:ss')
				.toFormat('dd.LL.y HH:mm');
		},
		phoneNumber ()
		{
			return this.message.appointment?.phone?.full;
		},
		phoneNumberFormatted ()
		{
			return this.message.appointment?.phone?.formatted;
		},
		hasLink ()
		{
			return !isEmptyOrNull(this.message.appointment?.accessLink ?? '');
		}
	},
}
</script>
